<template>
  <div :class="[backgroundClass, 'd-flex', 'align-center', 'justify-center', 'pa-4']">
    <div class="error-overlay-card">
      <Robin
        v-if="!$vuetify.breakpoint.xs"
        animation="swayandbounce"
        :showText="false"
        :loop="true"
        :width="150"
        :height="150"
      />
      <Typography variant="h-2" as="h1" class="error-overlay-headline">
        Uh oh, we had trouble loading your account. Please try logging in or refreshing the page.
      </Typography>
      <div class="error-overlay-contact">
        <CustomerServiceContact layout="stacked" />
      </div>
      <div class="error-overlay-buttons">
        <Button outlined class="error-overlay-btn-logout" @click="logout">Log out</Button>
        <Button class="error-overlay-btn-refresh" @click="refresh">REFRESH</Button>
      </div>
      <hr class="error-overlay-divider" aria-hidden="true" />
      <AppDebugBanner
        :tier-fail="failedWhitelabel || failedPermissions || blacklisted"
        :blacklisted="blacklisted"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Robin from "@/components/Robin.vue";
import AppDebugBanner from "@/components/app/AppDebugBanner.vue";
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import CustomerServiceContact from "@/components/help/CustomerServiceContact.vue";
import gradientBackgroundMixin from "@/mixins/gradientBackground";

export default {
  components: {
    Robin,
    AppDebugBanner,
    Typography,
    Button,
    CustomerServiceContact,
  },
  mixins: [gradientBackgroundMixin],
  props: {
    blacklisted: { type: Boolean, default: false },
  },
  methods: {
    logout() {
      this.$auth.logout({ returnTo: window.location.origin });
    },
    refresh() {
      document.location.reload();
    },
  },
  computed: {
    ...mapState(["failedWhitelabel", "failedPermissions"]),
  },
};
</script>

<style scoped>
.error-overlay-card {
  max-width: 846px;
  width: 100%;
  padding: 40px;
  border-radius: 8px;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
}
.error-overlay-headline {
  color: var(--v-surfaceText-base);
  text-align: center;
  margin: 0;
}
.error-overlay-contact {
  text-align: center;
  color: var(--v-surfaceText-base);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.error-overlay-contact p {
  margin: 0;
}
.error-overlay-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}
.error-overlay-btn-logout {
  border: 1px solid var(--v-brandPrimary-base) !important;
  color: var(--v-brandPrimary-base) !important;
  border-radius: 18px !important;
  padding: 8px 20px !important;
  font-family: Avenir, sans-serif !important;
  font-size: 14px !important;
  letter-spacing: 0.0893em !important;
  text-transform: uppercase !important;
}
.error-overlay-btn-refresh {
  background: var(--v-brandPrimary-base) !important;
  color: white !important;
  border-radius: 18px !important;
  padding: 8px 20px !important;
  font-family: Avenir, sans-serif !important;
  font-size: 14px !important;
  letter-spacing: 0.0893em !important;
  text-transform: uppercase !important;
}
.error-overlay-divider {
  border: none;
  border-top: 1px solid var(--v-surface-base);
  width: 100%;
  margin: 0;
}
@media (max-width: 600px) {
  .error-overlay-card {
    padding: 24px 16px;
  }
  .error-overlay-buttons {
    flex-direction: column;
    align-items: center;
  }
}
</style>
